var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbonLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 30,
    viewBox: "0 0 15 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.751 12.5012C14.9197 13.9621 14.9197 16.0379 13.751 17.4988L4.95098 28.4988C4.19189 29.4476 3.04263 30 1.8275 30L-2.26502e-06 30L-1.90735e-06 -5.24537e-07L1.8275 -5.24537e-07C3.04263 -5.24537e-07 4.19189 0.552358 4.95098 1.50122L13.751 12.5012Z",
    fill: "#F3F8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonLeft);
export default __webpack_public_path__ + "static/media/ribbon-left.f394c683c9eb265a17f618e920e6c3e4.svg";
export { ForwardRef as ReactComponent };